var map = {
	"./aws/info.en.mdx": "JdEl",
	"./aws/info.zh-TW.mdx": "U+bR",
	"./cathay-united-bank/info.en.mdx": "xzcC",
	"./cathay-united-bank/info.zh-TW.mdx": "3mjy",
	"./conquer-tech/info.en.mdx": "gX1k",
	"./conquer-tech/info.zh-TW.mdx": "tnf6",
	"./ctbc-bank/info.en.mdx": "wRcZ",
	"./ctbc-bank/info.zh-TW.mdx": "GEd5",
	"./e-cloud-valley/info.en.mdx": "9SkQ",
	"./e-cloud-valley/info.zh-TW.mdx": "nVIl",
	"./fable/info.en.mdx": "a8WU",
	"./fable/info.zh-TW.mdx": "qH+u",
	"./jet-brains/info.en.mdx": "qw6V",
	"./jet-brains/info.zh-TW.mdx": "JVnN",
	"./red-hat/info.en.mdx": "MUTu",
	"./red-hat/info.zh-TW.mdx": "dZgV",
	"./soft-leader/info.en.mdx": "3X+u",
	"./soft-leader/info.zh-TW.mdx": "TNSj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ug2M";